import React from 'react';
import { useState } from 'react';

export interface TabsProps {
  color: string;
  tabList: any;
}
const Tabs = ({ color, tabList, ...props }: TabsProps) => {
  const [currentTab, setCurrentTab] = useState<number>(0);
  const selectItemFromTabsHandler = (selectedTabNumber: number) => {
    setCurrentTab(selectedTabNumber);
  };

  // The div that has the menu should have a margin mt-[3.25rem] ml-[2.5rem] mr-[2.5rem]
  return (
    <div className="h-[42px] border-b-[1px] border-[#EEEEEE]">
      <div className="flex flex-row items-center p-0 w-full h-[39px] left-0  top-0">
        {tabList.map((tab: any, index: number) => {
          return (
            <button
              style={{ color, borderColor: color }}
              className={
                currentTab === index
                  ? 'flex flex-row justify-center items-center p-[10px_16px] gap-[10px] flex-none flex-grow-0 font-[Lato] not-italic font-[600] text-[16px] leading-[19px] text-[#554EF1] border-b-[3px] border-[#554EF1]'
                  : 'flex flex-row justify-center items-center p-[10px_16px] gap-[10px] flex-none flex-grow-0 font-[Lato] not-italic font-[400] text-[16px] leading-[19px] text-[#575757]'
              }
              onClick={() => {
                selectItemFromTabsHandler(index);
              }}
            >
              {tab.name}
              {tab.number !== undefined && (
                <span
                  style={{ color }}
                  className="font-[400] not-italic text-[12px] flex items-center order-1 flex-none flex-grow-0 leading-[14px]"
                >
                  {`(${tab.number})`}
                </span>
              )}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default Tabs;
